import { render, staticRenderFns } from "./SearchDrawer.vue?vue&type=template&id=36f22db8&scoped=true"
import script from "./SearchDrawer.vue?vue&type=script&lang=js"
export * from "./SearchDrawer.vue?vue&type=script&lang=js"
import style0 from "./SearchDrawer.vue?vue&type=style&index=0&id=36f22db8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f22db8",
  null
  
)

export default component.exports